import React from 'react';

import AlertDialog from '../../../components/AlertDialog/AlertDialog';
import {DialogButton} from '../../../components/AlertDialog/DialogContainer';
import DataGrid from '../../../components/DataGrid/DataGrid';
import {PaginationMode} from '../../../components/DataGrid/types';
import VoicemailDetailsDialog from './VoicemailDetailsDialog';
import VoicemailsFilterForm from './VoicemailsFilterForm';
import {UseVoicemailsReturn} from '../hooks/useVoicemails';

export interface VoicemailsContentProps {
    voicemails: UseVoicemailsReturn;
    showLoadingInGrid?: boolean;
}

const VoicemailsContent: React.FC<VoicemailsContentProps> = ({
    voicemails,
    showLoadingInGrid = false,
}) => {
    const {
        classes,
        t,
        userDateTimeFormat,
        isUpdatingMessageFlag,
        isDeletingVoicemail,
        detailsDialogProps,
        dialogVisible,
        data,
        columns,
        filterProps,
        onPageChange,
        onPageSizeChange,
        initialPageSize,
        onClickDelete,
        onCancelDeleteClick,
        getRowStyle,
        forceFirstPage
    } = voicemails;

    const {
        values,
        errors,
        handleSubmit,
        setFieldError,
        onFromChange,
        onTillChange,
        onSearchClick,
    } = filterProps;

    return (
        <>
            <VoicemailsFilterForm
                values={values}
                errors={errors}
                // @ts-ignore
                classes={classes}
                t={t}
                userDateTimeFormat={userDateTimeFormat}
                // @ts-ignore
                handleSubmit={handleSubmit}
                setFieldError={setFieldError}
                onFromChange={onFromChange}
                onTillChange={onTillChange}
                onSearchClick={onSearchClick}
            />

            <DataGrid
                // @ts-ignore
                className={classes.table}
                // @ts-ignore
                classes={{ pagination: classes.pagination }}
                columns={columns}
                data={data || []}
                rowCount={voicemails?.data?.length || 0}
                loading={isUpdatingMessageFlag || showLoadingInGrid}
                onPageChange={onPageChange}
                onPageSizeChange={onPageSizeChange}
                paginationMode={PaginationMode.Client}
                centeredRows
                pageSizeOptions={[5, 10, 15, 25, 50]}
                initialPageSize={initialPageSize}
                narrowRows
                customRowStyle={getRowStyle}
                forceFirstPage={forceFirstPage}
            />

            <AlertDialog
                isOpen={dialogVisible}
                description={t('screens:voicemails.deleteSelectedVoicemail')}
                contentClass="alert-content"
                // @ts-ignore
                className={classes.confirmDialogContainer}
                hideHeader={true}
                dialogActionsButtons={[
                    <DialogButton
                        key="cancel"
                        label={t('common:cancel')}
                        onClick={onCancelDeleteClick}
                        hidden={isDeletingVoicemail || !dialogVisible}
                    />,
                    <DialogButton
                        key="delete"
                        label={t('common:delete')}
                        onClick={onClickDelete}
                        dataQa="confirm-delete"
                        loadingAnimation={isDeletingVoicemail || !dialogVisible}
                    />,
                ]}
                dataQa="remove-modal"
                dataTestId="remove-modal"
            />

            <VoicemailDetailsDialog {...detailsDialogProps} />
        </>
    );
};

export default VoicemailsContent;